import React, { useEffect, useState } from 'react';
import { Box, IconButton, Modal, TextField, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { searchPlugin, SearchProps } from '@react-pdf-viewer/search';
//import '@react-pdf-viewer/core/lib/styles/index.css';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';

// Import styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

import { IViewDocument } from '@homeporter/types';
import { usePDFDocumentModalStyles } from './styles';
import { baseUrl } from '../../utils/helpers';

interface PDFViewModalProps {
  pdf: IViewDocument;
  closeModal: (value: boolean) => void;
  openModal: boolean;
}

const PDFViewModal = ({ pdf, openModal, closeModal }: PDFViewModalProps) => {
  const styles = usePDFDocumentModalStyles();
  const pdfUrl =
    pdf.type === 'FORM'
      ? baseUrl(pdf.source)
      : `${window._env_?.LIBRARY_BASE_URL || process.env.REACT_APP_LIBRARY_BASE_URL}/${pdf.key}/${pdf.source}`;
  const searchPluginInstance = searchPlugin();
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  const [searchQuery, setSearchQuery] = useState('');
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
  };

  // useEffect(() => {
  //   if (searchQuery.trim()) {
  //     searchPluginInstance.Search(searchQuery);
  //   }
  // }, [searchQuery, searchPluginInstance]);

  return (
    <>
      <Modal open={openModal} onClose={closeModal}>
        <Box sx={styles.modal}>
          <Box
            display={'flex'}
            justifyContent={'space-between'}
            paddingBottom={'1rem'}>
            <Typography paddingLeft={'2rem'} fontWeight={500}>
              Viewing PDF: {pdf.title}
            </Typography>
            {/* <TextField
              sx={{ borderRadius: '2rem' }}
              size={'small'}
              label={'Search'}
              value={searchQuery}
              onChange={handleSearchChange}
            /> */}
            <Box sx={{ paddingRight: '2rem' }}>
              <IconButton onClick={() => closeModal(true)}>
                <Close />
              </IconButton>
            </Box>
          </Box>
          <Box sx={styles.pdf}>
            {pdf ? (
              //<Worker workerUrl="https://unpkg.com/pdfjs-dist@3.6.172/build/pdf.worker.min.js">
              <Worker workerUrl="/pdf.worker.min.js">
                <Viewer
                  fileUrl={pdfUrl}
                  plugins={[searchPluginInstance, defaultLayoutPluginInstance]}
                />
              </Worker>
            ) : (
              <Typography>Failed to load PDF</Typography>
            )}
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default PDFViewModal;
